import getActionsByDocument from '../../../../components/logs/actions';

const DOCUMENT = 'JOB_LOGS_';

export default getActionsByDocument(DOCUMENT);
